import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Header from "../components/azhome/AzHeader";
import { useAuth } from "../context/AuthContext";
import "../auth.css";

const VerifyEmail = () => {
  const { verifyEmail } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setStatus("error"); setMessage(t("auth.verifyMissing")); return; }
    verifyEmail(token)
      .then(() => { setStatus("success"); setTimeout(() => navigate(process.env.REACT_APP_ADMIN_MODE === "true" ? "/admin" : "/dashboard"), 2200); })
      .catch((err) => { setStatus("error"); setMessage(err.response?.data?.detail || t("auth.verifyFailed")); });
  }, [params, verifyEmail, navigate, t]);

  return (
    <>
      <Header />
      <main className="auth-page">
        <div className="auth-card" data-testid="verify-email-page" style={{ textAlign: "center" }}>
          {status === "verifying" && (
            <>
              <Loader2 size={44} className="spin" style={{ margin: "0 auto 14px", color: "var(--accent,#0B5CFF)" }} />
              <h1>{t("auth.verifying")}</h1>
              <p className="auth-sub">{t("auth.verifyingSub")}</p>
            </>
          )}
          {status === "success" && (
            <div data-testid="verify-success">
              <CheckCircle2 size={48} style={{ margin: "0 auto 14px", color: "#16b979" }} />
              <h1>{t("auth.verifiedTitle")}</h1>
              <p className="auth-sub">{t("auth.verifiedSub")}</p>
            </div>
          )}
          {status === "error" && (
            <div data-testid="verify-error">
              <XCircle size={48} style={{ margin: "0 auto 14px", color: "#e0576a" }} />
              <h1>{t("auth.verifyFailedTitle")}</h1>
              <p className="auth-sub">{message}</p>
              <button className="auth-submit" type="button" onClick={() => navigate("/login")} style={{ marginTop: 10 }} data-testid="verify-error-login">{t("auth.loginLink")}</button>
            </div>
          )}
        </div>
      </main>
      <style>{`.spin{animation:vspin 1s linear infinite}@keyframes vspin{to{transform:rotate(360deg)}}`}</style>
    </>
  );
};

export default VerifyEmail;
